import Vue from 'vue';
import ChatMessageDialog from "../views/imessage/ChatMessageDialog";

const chatmsg = Vue.extend(ChatMessageDialog)

chatmsg.install = function (data) {
    let instance = new chatmsg({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.isShowDialog = true
    })

}

export default chatmsg
